import React from "react";
import { ArrowRight, ChevronDown } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=2400&q=80";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[100svh] flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Solaranlagen Schweizer Alpen"
          className="w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[var(--sol-bg)]/85 via-[var(--sol-bg)]/70 to-[var(--sol-bg)]" />
        <div className="absolute inset-0 grain" />
      </div>

      {/* Bronze accent glow */}
      <div
        aria-hidden
        className="absolute -top-40 left-1/2 -translate-x-1/2 w-[800px] h-[800px] rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(closest-side, rgba(200,162,122,0.18), rgba(200,162,122,0))",
        }}
      />

      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-10 pt-32 md:pt-40 pb-24 text-center">
        <p className="eyebrow fade-up delay-1" data-testid="hero-eyebrow">
          SOLANOVA GMBH
        </p>

        <h1
          data-testid="hero-headline"
          className="font-display text-white mt-8 text-5xl md:text-7xl lg:text-8xl font-extralight leading-[1.02] fade-up delay-2"
        >
          Willkommen bei der
          <br />
          <span className="bronze-metallic font-light">solanova gmbh</span>
        </h1>

        <p
          data-testid="hero-subhead"
          className="font-body mt-8 text-base md:text-xl text-white/65 max-w-2xl mx-auto leading-relaxed fade-up delay-3"
        >
          Ihr Ansprechpartner für Solaranlagen, Batteriespeichersysteme und Wallboxen
        </p>

        <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center fade-up delay-4">
          <button
            data-testid="hero-cta-primary"
            onClick={() => scrollTo("solar-check")}
            className="btn-bronze rounded-full px-8 py-4 inline-flex items-center justify-center gap-2 text-sm font-medium"
          >
            Kostenlosen Solar-Check starten
            <ArrowRight size={16} />
          </button>
          <button
            data-testid="hero-cta-secondary"
            onClick={() => scrollTo("leistungen")}
            className="btn-ghost rounded-full px-8 py-4 inline-flex items-center justify-center text-sm font-medium"
          >
            Leistungen entdecken
          </button>
        </div>

      </div>

      {/* Scroll cue */}
      <button
        data-testid="hero-scroll-cue"
        onClick={() => scrollTo("ueber-uns")}
        aria-label="Weiter scrollen"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/40 hover:text-white/80 transition-colors z-10"
      >
        <ChevronDown size={22} className="animate-bounce" />
      </button>
    </section>
  );
}
